// 套餐购买
<template>
  <div class="tcgm width1200 d-flex d-flex-jc-sb d-flex-fw-w">
    <div class="item" v-for="(item, index) in tcgmList" :key="index">
      <p class="title">{{ item.title }}</p>
      <dl>
        <dd
          v-for="(info, infoIndex) in item.data"
          :key="infoIndex"
          class="d-flex d-flex-aifs"
        >
          <div class="icon">
            <img
              :src="require('@/assets/images/icon9.png')"
              alt=""
              class="img1"
            />
            <img
              :src="require('@/assets/images/icon10.png')"
              alt=""
              class="img2"
            />
          </div>
          <span>{{ info.text }}</span>
        </dd>
        <a :href="item.link">购买</a>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tcgmList: [
        {
          title: "套餐1",
          link: process.env.VUE_APP_PORTAL_URL + 'httpTunnel/buy/1',
          data: [
            { text: "20元/日,500元/月,1470元/季度,5700元/年" },
            { text: "全国混合随机IP" },
            { text: "支持HTTP/HTTPS协议" },
            { text: "IP持续使用时间1～2分钟" },
            { text: "支持自主切换IP" },
            { text: "单账号每秒请求数默认10个，可以升级到100个" },
            { text: "同一账号同一时间所有请求锁定同一个出口IP" },
            { text: "百万级IP池，覆盖全国大部分地区" },
          ],
        },
        {
          title: "套餐2",
          link: process.env.VUE_APP_PORTAL_URL + 'httpTunnel/buy/2',
          data: [
            { text: "24元/日,600元/月,1764元/季度,6840元/年" },
            { text: "全国混合随机IP" },
            { text: "支持HTTP/HTTPS协议" },
            { text: "IP持续使用时间7～10分钟" },
            { text: "支持自主切换IP" },
            { text: "单账号每秒请求数默认10个，可以升级到100个" },
            { text: "同一账号同一时间所有请求锁定同一个出口IP" },
            { text: "百万级IP池，覆盖全国大部分地区" },
          ],
        },
        {
          title: "套餐3",
          link: process.env.VUE_APP_PORTAL_URL + 'httpTunnel/buy/3',
          data: [
            { text: "17元/日,425元/月, 1249.5元/季度, 4845元/年" },
            { text: "全国混合随机IP" },
            { text: "支持HTTP/HTTPS协议" },
            { text: "每个请求随机分配IP" },
            { text: "单账号每秒请求数默认5个，可以升级到100个" },
            { text: "百万级IP池，覆盖全国大部分地区" },
          ],
        },
      ],
    };
  },

};
</script>

<style lang="less" scoped>
.tcgm {
  padding: 97px 0 66px;
  .item {
    width: 364px;
    height: 762px;
    border: 5px solid #f78834;
    border-radius: 16px;
    position: relative;
    transition: all 0.3s;
    .title {
      font-size: 24px;
      color: #111;
      font-weight: bold;
      margin: 26px 0 0 50px;
    }
    dl {
      width: 240px;
      margin: 0 auto;
      dd {
        font-size: 18px;
        color: #111;
        margin-top: 20px;
        img {
          margin-right: 18px;
          &.img2 {
            display: none;
          }
        }
      }
      a {
        display: inline-block;
        width: 168px;
        line-height: 48px;
        background: #f78834;
        font-size: 20px;
        color: #fff;
        text-align: center;
        border-radius: 10px;
        position: absolute;
        bottom: 36px;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
    &:hover {
      background: #f78834;
      transform: translate(0, -45px);
      box-shadow: 0 2px 20px 6px #fddec7;
      .title {
        color: #fff;
      }
      dl {
        dd {
          color: #fff;
          img {
            &.img1 {
              display: none;
            }
            &.img2 {
              display: block;
            }
          }
        }
        a {
          background: #fff;
          color: #f78834;
        }
      }
    }
  }
}
@media (max-width: 1534px) {
  .tcgm {
    padding: 3% 0;
  }
  .tcgm .item {
    width: 32%;
  }
}
@media (max-width: 1480px) {
  .width1394 {
    width: 96%;
  }
  .tcgm .item .title {
    margin: 4% 0 0 6%;
  }
  .tcgm .item dl {
    width: 86%;
  }
}
// @media (max-width: 1200px) {
//   .tcgm .item {
//     height: 680px;
//     margin-bottom: 2%;
//   }
// }
@media (max-width: 768px) {
  .tcgm .item {
    margin-bottom: 2%;
    width: 100%;
    height: 640px;
  }
  .tcgm .item .title {
    font-size: 16px;
  }
  .tcgm .item dl dd,
  .tcgm .item dl a {
    font-size: 14px;
  }
  .tcgm .item dl dd img {
    width: 20px;
  }
}
</style>
